import { render } from "./NetworkError.vue?vue&type=template&id=11ed167c"
const script = {}
script.render = render

export default script